import { render, staticRenderFns } from "./RsaConfigurazioneStrutturaProvenienzaRepartiEditModalComponent.vue?vue&type=template&id=1be6ab4a"
import script from "./RsaConfigurazioneStrutturaProvenienzaRepartiEditModalComponent.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazioneStrutturaProvenienzaRepartiEditModalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports